module.exports = __webpack_public_path__ + "img/logo-peace-dark.120982e1.png";